import { render, staticRenderFns } from "./matrix-page.vue?vue&type=template&id=1318e44d"
import script from "./matrix-page.vue?vue&type=script&lang=js"
export * from "./matrix-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports